import { Provider } from 'react-redux';
import { EnvironmentThemeProvider as BrightworldEnvironmentThemeProvider } from '@codex-brightworld/themes';
import { EnvironmentThemeProvider } from '@codex/themes';
import { wasPriceDateTrimYear, resolveByCountry } from '@codex/helpers';

import PricePromiseTab from '../components/react/PricePromise/PricePromiseTab';
import initProductImagesSection
  from '../components/react/ProductPageProductImagesSection/initProductImagesSection';
import initCountdowns from './countdowns.js';
import initProductSwatches from '../components/react/productSwatches';

import { addProductInfo } from '../appState/ducks/productInfo.js';
import AddedValueMessages from '../components/react/AddedValueMessages/AddedValueMessages.jsx';
import AddedValueMessagesTab from
  '../components/react/AddedValueMessages/AddedValueMessagesTab.jsx';
import ProductSizing from '../components/react/ProductSizing';

import TariffDetails from '../components/react/TariffDetails/TariffDetails';
import CareplanSwatches from '../components/react/CareplanSwatches/CareplanSwatches';
import SharingIcons from '../components/react/SharingIcons/SharingIcons';
import EnergyLabel from '../components/react/EnergyLabel/EnergyLabel';

import initBundles from '../components/react/StepPageBundles/StepPageBundles';
import initProductPageBundles
  from '../components/react/ProductPageBundles/ProductPageBundles';
import AddToBasketButtonWithAjaxCall
  from '../components/react/AddToBasket/AddToBasketButtonWithAjaxCall.jsx';
import AddToBasketFailedPopupWrapper
  from '../components/react/AddToBasket/AddToBasketFailedPopup/AddToBasketFailedPopupWrapper';
import initAddToBasketButtonWrapper from
  '../components/react/UserEligibilityCheck/helpers/AddToBasketButtonWrapper';
import initCompareBlock from '../components/react/Compare/initCompareBlock.jsx';
import initComparePopup from '../components/react/ComparePopup/initComparePopup.jsx';
import initPriceMatch from '../components/react/PriceMatchGuarentee/initPriceMatch';

import uiLocale from '../utils/UILocale';
import ProductPriceBlockWrapper, { VARIANT_FO_SITE_PRODUCT_PAGE } from
  '../components/react/ProductPriceBlock/ProductPriceBlockWrapper';
import initTradeUp from './tradeUp';

import initCredit from '../components/react/Credit/initCredit';
import { psaVariants } from '../components/react/PopupStyleAttach/components/PSAPopup/PSAPopup';
import { initPSAPopup } from './popupStyleAttach';
import ProductPageSpecificationTab
  from '../components/react/ProductPageSpecificationTab/ProductPageSpecificationTab';

const React = require('react');
const ReactDOM = require('react-dom');

const globalInit = require('./global.js');
const reevooEmbeddedController = require('../reevoo-embedded-controller');
const BlueBoxWrapper =
  require('../components/native/price-promise-blue-box/blue-box-wrapper.es6').default;
const UISettings = require('../utils/UISettings.js');
const UIProductAvailability = require('../components/productavailability');
const ProductAvailability = require('../productavailability');
const LocationService = require('../locationservice');
const productPageTabs = require('../components/productPageTabs.js');
const simpleTabs = require('../simple-tabs.js');
const simpleToggle = require('../simple-toggle');
const sticky = require('../sticky.js');
const accordion = require('../accordion.js');
const domUtils = require('../domutils.js');

const SaveForLater = require('../components/react/SaveForLater/SaveForLater');

const oosEmail = require('../email-oos');
const UITourGuide = require('../components/tourGuide.js');
const printer = require('../printer.js');

const flixmedia = require('../flixmedia.js');

function createPriceMatch() {
  const desktopContainer = document.querySelector('[data-component="price-match-desktop"]');
  const touchDeviceContainer = document.querySelector('[data-component="price-match-touch"]');

  if (desktopContainer) {
    initPriceMatch(desktopContainer);
  }
  if (touchDeviceContainer) {
    initPriceMatch(touchDeviceContainer);
  }
}

function createCreditMessage() {
  const desktopContainer = document.querySelector('[data-component="product-credit-info-desktop"]');
  const touchDeviceContainer =
    document.querySelector('[data-component="product-credit-info-touch"]');

  if (desktopContainer) {
    initCredit(desktopContainer);
  }

  if (touchDeviceContainer) {
    initCredit(touchDeviceContainer);
  }
}

function initCompareTool() {
  // check if some products from this segment was already compared
  const currentSegmentId = window.digitalData.page.category
    ? window.digitalData.page.category.segmentId.toString() : '';
  const comparedSegments = Object.keys(window.appState.getState().listingPage.comparison.products);
  const showCompare = comparedSegments.includes(currentSegmentId);
  const tradeUpSwitch = UISettings.get('component.tradeUp.enabled');

  // Compare panel and compare checkboxes
  if (showCompare || tradeUpSwitch) {
    const comparePanel = document.querySelector('[data-component="compare-panel"]');
    const checkboxWrapper = document.getElementById('video-with-compare-checkbox');
    if (checkboxWrapper) {
      checkboxWrapper.classList.add('withCompareCheckbox');
    }
    if (comparePanel) {
      initCompareBlock(comparePanel, true);
      sticky.initialiseCompare('[data-component="compare-panel"]');
    }
    // Compare pop up
    const comparePanelPopup = document.querySelector('[data-component="compare-panel-popup"]');
    if (comparePanelPopup) {
      initComparePopup(comparePanelPopup);
    }
  }
}

function setRecylingLabelBelowPriceBlockForIreland() {
  const recyclingMessageElement = document.querySelector('div.prd-recycling-charge');

  if (recyclingMessageElement) {

    console.log(recyclingMessageElement.textContent);
    $(`<div class="prd-recycling-charge">${recyclingMessageElement.textContent}</div>`)
      .insertBefore('div.prd-links-container');

  }
}

function initTariffDetails() {
  const td = window.digitalData.product[0].tariffDetails;

  ['.left-div', '.no-tablet'].forEach((parentSelector) => {
    const tariffDetailsWrapper =
      document.querySelector(`${parentSelector} [data-component="tariff-info"]`);

    if (tariffDetailsWrapper && td) {
      ReactDOM.render(
        <TariffDetails details={td} />, tariffDetailsWrapper
      );
    }
  });
}

function initSharingIcons() {
  const sharingWrapper = document.querySelector('[data-component="sharingIcons"]');
  const shareLinks = window.shareLinks || [];

  if (sharingWrapper && (shareLinks.length > 0)) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <SharingIcons
          links={shareLinks}
        />
      </Provider>, sharingWrapper
    );
  }
}

function initEnergyLabel() {
  const labelData = UISettings.get('component_energy_rating') || null;
  ['.left-div', '.no-tablet'].forEach((parentSelector) => {
    const energyLabelWrapper =
      document.querySelector(`${parentSelector} [data-component="energy-label"]`);
    const oldEnergyLabels =
      document.querySelector(`${parentSelector} div.energy-rating`);

    if (energyLabelWrapper && labelData && labelData.classTag) {
      const labelTitle = labelData.labelAltTitle;
      const newSvg = (labelData.classTag)
        .replace(/<title>(.*)<\/title>/g, `<title>${labelTitle}</title>`);

      if (oldEnergyLabels) {
        oldEnergyLabels.style.display = 'none';
      }

      ReactDOM.render(
        <EnergyLabel
          labelSrc={newSvg}
          labelLink={labelData.labelDownloadLink}
          ficheTitle={labelData.ficheTitle}
          ficheLink={labelData.ficheDownloadLink}
        />, energyLabelWrapper
      );
    }
  });
}

function initCareplanSwatches() {
  ['.left-div', '.no-tablet'].forEach((parentSelector) => {
    const careplanWrapper =
      document.querySelector(`${parentSelector} [data-component="careplanSwatchesWrapper"]`);

    if (careplanWrapper) {
      const carePlanTranslations = {
        compareWarranties: uiLocale.getString('component.carePlan.comparingWarranties'),
        termsAndConditions: uiLocale.getString('component.carePlan.termsAndCondition'),
        header: uiLocale.getString('component.careplan.careplan_component_title'),
        carePlanExclusions: [
          uiLocale.getString(
            'component.carePlan.careplan_exclusion_accidental_damage'
          ),
          uiLocale.getString(
            'component.carePlan.careplan_exclusion_cosmetic_damage'
          )
        ],
        instantReplacement: [
          uiLocale.getString(
            'component.carePlan.instantReplacement.benefit1'
          ),
          uiLocale.getString(
            'component.carePlan.instantReplacement.benefit2'
          )
        ],
        moreInfo: uiLocale.getString('component.avm.more_details')
      };

      ReactDOM.render(
        <Provider store={window.appState}>
          <BrightworldEnvironmentThemeProvider>
            <CareplanSwatches
              translations={carePlanTranslations}
            />
          </BrightworldEnvironmentThemeProvider>
        </Provider>, careplanWrapper
      );
    }
  });
}

function initAddToBasketButton(psaVariant) {
  const addToBasketButtonWrappers =
    Array.from(document.querySelectorAll('[data-component="add-to-basket-button-wrapper"]'));

  addToBasketButtonWrappers.forEach((addToBasketButtonWrapper) => {
    ReactDOM.render(
      <AddToBasketButtonWithAjaxCall
        fupid={addToBasketButtonWrapper.dataset.fupid}
        quantity={1}
        buttonLabel={addToBasketButtonWrapper.dataset.buttonLabel}
        download={addToBasketButtonWrapper.hasAttribute('data-download')}
        psaVariant={psaVariant}
        buttonPlacementID={'main'}
      />,
      addToBasketButtonWrapper
    );
  });
}

function initAddBundleToBasketButtons() {
  const addBundleToBasketButtons =
    document.querySelectorAll('[data-component="bundle-add-to-basket-button"]');

  if (addBundleToBasketButtons) {
    addBundleToBasketButtons.forEach((addBundleToBasketElem) => {
      ReactDOM.render(
        <AddToBasketButtonWithAjaxCall
          fupid={addBundleToBasketElem.dataset.fupid}
          quantity={1}
          buttonLabel={addBundleToBasketElem.dataset.buttonLabel}
        />,
        addBundleToBasketElem
      );
    });
  }
}

function initAddingToBasketFailedPopup() {
  const wrapperElements =
    document.querySelectorAll('[data-component="addToBasketFailedPopupWrapper"]');

  wrapperElements.forEach((wrapperElement) => {
    if (wrapperElement) {
      ReactDOM.render(
        <Provider store={window.appState}>
          <AddToBasketFailedPopupWrapper />
        </Provider>,
        wrapperElement
      );
    }
  });
}

/*  functionality for services checkboxes postponed

function initInstallServiceCheckboxes() {
  const checkboxWrappers =
    document.querySelectorAll('[data-component="installationCheckboxWrapper"]');

  checkboxWrappers.forEach((checkboxWrapper) => {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ServiceCheckboxContainer
          linkHashURL="#tab5|install"
          linkLabel={window.installServiceData.moreInfoLabel}
          messageLabel={window.installServiceData.checkboxLabel}
          price={window.installServiceData.sPriceIAT}
          serviceID={window.installServiceData.iInternalRef}
          serviceType="install"
        />
      </Provider>,
      checkboxWrapper
    );
  });
}

function initRecycleServiceCheckboxes() {
  const checkboxWrappers =
    document.querySelectorAll('[data-component="recyclingCheckboxWrapper"]');

  checkboxWrappers.forEach((checkboxWrapper) => {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ServiceCheckboxContainer
          linkHashURL="#tab5|recycling"
          linkLabel={window.recycleServiceData.moreInfoLabel}
          messageLabel={window.recycleServiceData.checkboxLabel}
          price={window.recycleServiceData.sPriceIAT}
          serviceID={window.recycleServiceData.iInternalRef}
          serviceType="recycle"
        />
      </Provider>,
      checkboxWrapper
    );
  });
}
*/

function initAddedValueMessages() {
  const avms = UISettings.get('addedValueMessages');
  const simpleOfferCount = avms.messages.filter((v) => v.simpleOffer).length;

  ['.left-div', '.no-tablet'].forEach((parentSelector) => {
    const rootEl =
      document.querySelector(`${parentSelector} [data-component="avms"]`);

    if (rootEl && simpleOfferCount >= 1) {
      ReactDOM.render(
        <BrightworldEnvironmentThemeProvider>
          <AddedValueMessages data={avms} />
        </BrightworldEnvironmentThemeProvider>, rootEl
      );
    }
  });
}

function initAddedValueMessagesTab() {
  const avms = UISettings.get('addedValueMessages');
  const avmsTabWrapper = document.querySelector('[data-component="avms-tab"]');

  if (avmsTabWrapper) {
    ReactDOM.render(
      <AddedValueMessagesTab data={avms} />, avmsTabWrapper
    );
  }
}

function initSaveForLater(groupcallIsLoading) {
  if (!groupcallIsLoading) {
    SaveForLater.init();
  }
}

function initReduxStoreProductInfoFromDigitalData() {
  if (window.digitalData && window.digitalData.product && window.digitalData.product[0]) {
    window.appState.dispatch(addProductInfo(window.digitalData.product[0]));
  }
}

function initTabsAndToggles() {
  simpleTabs.bindTabs();
  simpleToggle('.dcg-toggle-lk');
}

async function initSpecificationTabContent() {
  // checking if specification tab is in the document
  const specificationTabHeader = document.querySelector('#tab2');
  const specificationTabContent = document.querySelector('#tab2 > div.tab-tech-specs');
  const tabContent = document.querySelector('#tab2 > div.tab-tech-specs > div.productSheet');

  if (specificationTabHeader && specificationTabContent && tabContent) {
    // after first click on the specification tab header, the component for its content is rendered
    specificationTabHeader.addEventListener('click', () => {
      let fetchURL;

      const productID = window.digitalData.product[0].productID;
      if (window.location.hostname === 'localhost') {
        // this URL is for development on localhost
        fetchURL = `https://localhost:8080/store/api/products/${productID}/technical-specifications`;
      } else {
        fetchURL = `${window.App.settings.get('global.store_api_url')}/products/${productID}/technical-specifications`;
      }

      ReactDOM.render(
        <EnvironmentThemeProvider>
          <ProductPageSpecificationTab
            fetchProductDataURL={fetchURL}
          />
        </EnvironmentThemeProvider>, tabContent
      );

      // this event is handled only once after first click on the tab header
    }, { once: true });

  }
}

function initStockChecker() {
  function initProductAvailability(groupcallIsLoading) {
    if (groupcallIsLoading) {
      return;
    }
    let autocheck = UISettings.get('app.productavailability.autocheck');
    let autocheckForMobiles = UISettings.get('app.productavailability.autocheckForMobiles');
    autocheck = autocheck === undefined ? true : autocheck;
    autocheckForMobiles = autocheckForMobiles === undefined ? false : autocheckForMobiles;
    autocheck = autocheck &&
      (autocheckForMobiles || window.App.Platform.isTablet() || window.App.Platform.isDesktop());

    const uiProductAvailability = new UIProductAvailability(true);
    let availabilityData = UISettings.get('productAvailability', UISettings.Type.USER);
    const lastPostCode = UISettings.get('lastPostCode', UISettings.Type.USER);
    const lastCoords = UISettings.get('lastCoords', UISettings.Type.USER);

    if (lastCoords) {
      availabilityData = {
        ...availabilityData,
        data: {
          ...((availabilityData && availabilityData.data) || {}),
          lastCoords
        }
      };
    }

    $('article[data-component="locationsearch"] > label')
      .text(uiLocale.getString('component.mcd.postcodechecker.check.availability'));

    LocationService.load();

    if (autocheck && initProductAvailability && availabilityData && lastPostCode) {
      LocationService.setAutomaticStockChecker(lastPostCode);
      const productAvailability = new ProductAvailability(availabilityData.data, lastPostCode);
      uiProductAvailability.setAvailability(productAvailability);
    } else {
      uiProductAvailability.onready();
    }
  }

  UISettings.watchChanges('groupcallIsLoading', UISettings.Type.USER, initProductAvailability);
  initProductAvailability(UISettings.get('groupcallIsLoading', UISettings.Type.USER));

  UISettings.watchChanges('groupcallIsLoading', UISettings.Type.USER, initSaveForLater);
  initSaveForLater(UISettings.get('groupcallIsLoading', UISettings.Type.USER));

}

function initProductActions() {
  const productActionToggleEl = $('#product-actions-toggle');
  const contentEl = $('#content');
  productActionToggleEl.insertAfter(contentEl);
}

function initPricePromise() {
  const productHeader = document.querySelector('.page-title[data-price-promise-enabled]');
  if (productHeader) {
    BlueBoxWrapper.init(
      productHeader,
      window.App.settings.get('pricePromiseData', window.App.settings.Type.USER)
    );
  }
}

function initProductSizingSection() {
  const productSizeAndPackageSectionEl = document.getElementById('product-size-and-package');
  const svgImageList = UISettings.get('dimensions');
  if (productSizeAndPackageSectionEl && svgImageList) {
    const { url } = productSizeAndPackageSectionEl.dataset;
    ReactDOM.render(
      <ProductSizing imageBasePath={url} svgImageList={svgImageList} />,
      productSizeAndPackageSectionEl
    );
  }
}


function sendPromotionalCreditDataToDataLayer() {
  const promoCredit = UISettings.get('promotionalCredit');
  window.appState.dispatch({
    type: 'PROMOTIONAL_CREDIT_PRODUCT_PAGE',
    payload: promoCredit
  });
}

function initializePricePromiseTable() {
  const pricePromiseElement = document.querySelector('[data-component="price-promise-table"]');
  if (pricePromiseElement) {
    ReactDOM.render(
      <PricePromiseTab
        productName={document.querySelector('h1.page-title').innerText}
        {...window.App.settings.get('pricePromiseData', window.App.settings.Type.USER)}
      />,
      pricePromiseElement
    );
  }
}

// TODO: remove this old version of credit info popup as there is createCreditMessage() now
function initCreditInfoPopupClickHandlers() {
  const productCreditLinks = domUtils.qall('li[data-item="productCreditAvailable"]', document);

  for (let i = 0; i < productCreditLinks.length; i++) {

    // add click event listener to link in order to show/hide popup onclick the link
    productCreditLinks[i].querySelector('a').addEventListener('click', (e) => {
      const creditInfoPopup = productCreditLinks[i].querySelector('div.credit-info');
      if (domUtils.hasClass(creditInfoPopup, 'visible')) {
        domUtils.removeClass(creditInfoPopup, 'visible');
      } else {
        domUtils.addClass(creditInfoPopup, 'visible');
      }
    });

    // add click event listener to cross button within popup to hide popup onclick the button
    const crossIcon = productCreditLinks[i].querySelector('i.dcg-icon-cross');
    if (crossIcon) {
      crossIcon.addEventListener('click', (e) => {
        const creditInfoPopup = productCreditLinks[i].querySelector('div.credit-info');
        domUtils.removeClass(creditInfoPopup, 'visible');
      });
    }

    // add click event listener to 'more info' link within popup in order to hide popup onclick link
    productCreditLinks[i].querySelector('a.bullet-link.anchor-lk')
      .addEventListener('click', (e) => {
        const creditInfoPopup = productCreditLinks[i].querySelector('div.credit-info');
        domUtils.removeClass(creditInfoPopup, 'visible');
      });
  }
}

const initPriceBlock = () => {
  const priceElementItems = document.getElementsByClassName('amounts');
  const state = window.appState.getState();
  const currency = resolveByCountry('GBP', 'EUR');
  const productInfo = state && state.productInfo;
  if (productInfo) {
    const {
      currentPrice,
      isInStock,
      savingsPrice,
      wasPrice,
      wasPriceFrom,
      wasPriceTo,
      mainProductWasPrice,
      mainProductCurrentPrice,
      separateSellingPrice,
      inStorePrice,
      perMonthPrice,
      isFlashSale
    } = productInfo;

    const translations = {
      mainProductWasPriceTranslation:
        uiLocale.getString('component.productPage.mainProductWasLabel'),
      mainProductCurrentPriceTranslation:
        uiLocale.getString('component.productPage.nowLabel'),
      separateSellingPriceTranslation:
        uiLocale.getString('component.productPage.separate_selling_price'),
      inStorePriceTranslation:
        uiLocale.getString('component.productPage.priceInstoreLabel'),
      perMonthTranslation:
        uiLocale.getString('component.productPage.perMonthLabel'),
      webExclusivePriceTranslation:
        uiLocale.getString('component.productPage.webExclusiveLabel')
    };

    priceElementItems.forEach((priceElement, i) => {
      ReactDOM.render(
        <ProductPriceBlockWrapper
          currentPrice={currentPrice}
          savingsPrice={savingsPrice}
          wasPrice={wasPrice}
          wasPriceFrom={wasPriceFrom ? wasPriceDateTrimYear(wasPriceFrom) : undefined}
          wasPriceTo={wasPriceFrom ? wasPriceDateTrimYear(wasPriceTo) : undefined}
          currency={currency}
          fromDateTranslation={'from'}
          toDateTranslation={'to'}
          isOutOfStock={!isInStock}
          mainProductWasPrice={mainProductWasPrice}
          mainProductCurrentPrice={mainProductCurrentPrice}
          separateSellingPrice={separateSellingPrice}
          mainProductWasPriceTranslation={translations.mainProductWasPriceTranslation}
          mainProductCurrentPriceTranslation={
              translations.mainProductCurrentPriceTranslation
            }
          displayBundlePriceInsidePriceBlock
          separateSellingPriceTranslation={translations.separateSellingPriceTranslation}
          inStorePrice={inStorePrice}
          inStorePriceTranslation={translations.inStorePriceTranslation}
          displayInStorePriceInsidePriceBlock
          perMonthPrice={perMonthPrice}
          perMonthTranslation={translations.perMonthTranslation}
          isFlashSale={isFlashSale}
          webExclusivePriceTranslation={translations.webExclusivePriceTranslation}
          variant={VARIANT_FO_SITE_PRODUCT_PAGE}
        />,
        priceElement
      );
    });
  }
};

const productPageInit = {

  DOMReadyInit: function DOMReadyInit() {
    initReduxStoreProductInfoFromDigitalData();
    initProductImagesSection();

    /**
     * FOLLOWING COMMENTED CODE IS USED FOR INIT OF PSA
     * HOWEVER CURRENT IMPLEMENTATION OF PSA IS BUGGY
     * SO IT'S HARDLY TURNED OFF THERE
     * IN ORDER TO MAKE PSA WORK AGAIN
     * IT HAS TO BE FUNDAMENTALLY REWRITTEN
     *
     * if (UISettings.get('component.psa.variant')) {
     *  // init PSA for adding to basket
     * initProductAttachments();
     * } else
     */
    const psaVariant = psaVariants[UISettings.get('component.psa.variant')];
    const psaRecycleAndInstallEnabled = UISettings.get('component.psa.ri.enabled');
    const psaWhenBoughtWithEnabled = UISettings.get('component.psa.wbw.enabled');

    if (window.digitalData.product[0].tariffDetails &&
      window.digitalData.product[0].tariffDetails.isUpgrade === true) {
      initAddToBasketButtonWrapper(initAddToBasketButton);
    } else {
      initAddToBasketButton(psaVariant);
      initPSAPopup(psaVariant, psaRecycleAndInstallEnabled, psaWhenBoughtWithEnabled);
    }

    initAddBundleToBasketButtons();
    initAddingToBasketFailedPopup();
    /*  functionality for services checkboxes postponed
    initInstallServiceCheckboxes();
    initRecycleServiceCheckboxes();
    */
    initTabsAndToggles();
    initSpecificationTabContent();
    initStockChecker();
    initProductSwatches();
    initTariffDetails();
    initCareplanSwatches();
    initAddedValueMessages();
    initAddedValueMessagesTab();
    initSharingIcons();
    initEnergyLabel();
    initPricePromise();
    UITourGuide.init();
    productPageTabs.init();
    initProductActions();
    oosEmail.initFormSubmit('.email-when-back-form');
    accordion.initialise();
    initCountdowns();
    initProductSizingSection();
    initializePricePromiseTable();
    sendPromotionalCreditDataToDataLayer();
    initCreditInfoPopupClickHandlers();
    createPriceMatch();
    createCreditMessage();
    // Print DOM preparation
    printer('.to-print', 'product-page-print', false);
    flixmedia('flix-inpage', window.sFlixMediaLabel);
    initBundles(psaVariant);
    initProductPageBundles(psaVariant);

    initCompareTool();
    if (resolveByCountry(false, true)) {
      setRecylingLabelBelowPriceBlockForIreland();
    }
    initPriceBlock();
    initTradeUp();
    if (window.DCG.isReevooActive) {
      reevooEmbeddedController({
        scriptUrl: '//mark.reevoo.com/assets/embedded_reviews.js',
        contents: '#reevoo-embedded-contents'
      });
    }

    // sticky has to be initialized last to determine right offset positions
    sticky.initialise(['#product-actions.desktop']);
  },
  init: function init() {
    // load CSS for Reevoo after page load
    productPageTabs.loadCSSForReevooAfterPageLoad();
  }
};

globalInit.initPage(productPageInit);
